import axios from 'axios';

import { WsPriceBoardParamsTypes } from './types';

const getWsPriceboardService = async (
  params: WsPriceBoardParamsTypes,
): Promise<SocketResponseTypes> => {
  const formData = new FormData();
  formData.append('selectedStocks', params.selectedStocks);
  formData.append('criteriaId', params.criteriaId);
  formData.append('marketId', params.marketId.toString());
  formData.append('lastSeq', params.lastSeq.toString());
  formData.append('isReqTL', params.isReqTL.toString());
  formData.append('isReqMK', params.isReqMK.toString());
  formData.append('tlSymbol', params.tlSymbol);
  formData.append('pthMktId', params.pthMktId);
  formData.append('isGetNullValue', params.isGetNullValue.toString());
  formData.append('isIncrValue', params.isIncrValue.toString());
  const res = await axios.post(`${process.env.REACT_APP_SOCKET_URL}/Acc/amw`, formData);
  return res.data;
};
export default getWsPriceboardService;
